export default {
  dashboard: {
    activeSurveyNotSelected: `<title>Inventário ativo não selecionado</title>
      <p><label>Selecione um na</label><linkToSurveys>Lista de Inventários</linkToSurveys> ou <linkToNewSurvey>Crie um novo</linkToNewSurvey></p>`,
    activeUsers: 'Usuários ativos',
    activityLog: {
      title: 'Log de atividades',
      size: 'Tamanho do $t(homeView:dashboard.activityLog.title): {{size}}',
      loadError: 'Não foi possível carregar a atividade.',
      empty: 'Ainda não há atividade.',
    },
    exportWithData: 'Exportar + dados (Backup)',
    exportWithDataNoActivityLog: 'Exportar + dados (SEM log de atividades)',
    exportWithDataNoResultAttributes: 'Exportar + dados (SEM atributos de resultado)',
    surveyPropUpdate: {
      main: `<title>Bem-vindo ao Arena</title>
  
        <p>Primeiro você precisa definir o <strong>nome</strong> e o <strong>rótulo</strong> do inventário.</p>
        
        <p>Clique abaixo em <linkWithIcon>$t(homeView:surveyInfo.editInfo)</linkWithIcon> ou no nome do inventário: <basicLink>{{surveyName}}</basicLink></p>
        `,
      secondary: `
        <p>Se nome e rótulo estiverem corretos, crie o primeiro atributo
        <linkWithIcon>Inventário \u003E Designer do formulário</linkWithIcon>
        </p>
        `,
    },
    nodeDefCreate: {
      main: `<title>Vamos criar o primeiro atributo de {{surveyName}}</title>
        
        <p>Vá para <linkWithIcon>Inventário \u003E Designer do formulário</linkWithIcon></p>
        <br />
        `,
    },
    storageSummary: {
      title: 'Uso de armazenamento',
      availableSpace: 'Disponível ({{size}})',
      usedSpace: 'Usado ({{size}})',
      usedSpaceOutOf: `Usado {{percent}}% ({{used}} de {{total}})`,
    },
    storageSummaryDb: {
      title: 'Uso de armazenamento (Banco de dados)',
    },
    storageSummaryFiles: {
      title: 'Uso de armazenamento (arquivos)',
    },
    samplingPointDataCompletion: {
      title: 'Conclusão de Dados de Pontos Amostrais',
      totalItems: 'Total de itens: {{totalItems}}',
      remainingItems: 'Itens restantes',
    },
    kpi: {
      records: 'Registros',
      contributors: 'Colaboradores',
      storage: 'Armazenamento',
      expandDetails: 'Mostrar detalhes',
      collapseDetails: 'Ocultar detalhes',
    },
    recordsCard: {
      total: 'Registros adicionados no período selecionado',
      byStep: 'Por etapa do fluxo de trabalho (todo o período)',
    },
    contributorsCard: {
      active: 'Colaboradores ativos no período selecionado: {{count}}',
    },
    map: {
      title: 'Mapa',
      allOwners: 'Todos os proprietários',
    },
    step: {
      entry: 'Entrada de dados',
      cleansing: 'Limpeza de dados',
      analysis: 'Análise de dados',
    },
    recordsByUser: 'Registros por usuário',
    recordsAddedPerUserWithCount: 'Registros adicionados por usuário (Total de {{totalCount}})',
    dailyRecordsByUser: 'Registros diários por usuário',
    totalRecords: 'Total de registros',
    selectUsers: 'Selecionar usuários...',
    noRecordsAddedInSelectedPeriod: 'Nenhum registro adicionado no período selecionado',
  },
  surveyDeleted: 'O inventário {{surveyName}} foi excluído',
  landing: {
    openDashboard: 'Abrir painel',
  },
  surveyInfo: {
    basic: 'Informações básicas',
    branding: {
      title: 'Marca',
      primaryColor: 'Cor primária',
      titleFontSize: 'Tamanho da fonte do título',
      descriptionFontSize: 'Tamanho da fonte da descrição',
      fontSizePreset: {
        small: 'Pequeno',
        default: 'Padrão',
        large: 'Grande',
      },
      surveyLogo1: 'Logo do inventário 1',
      surveyLogo2: 'Logo do inventário 2',
      surveyLogo3: 'Logo do inventário 3',
      landingBackground: 'Imagem de fundo da página inicial',
      uploadLogo: 'Enviar logo',
      logoFileFormatHint: 'PNG, JPEG, WebP ou SVG (máx. {{maxMb}} MB)',
      logoFileTooLarge: 'A imagem do logo deve ter {{maxMb}} MB ou menos',
      preview: 'Pré-visualização',
      backgroundFileTooLarge: 'A imagem de fundo deve ter {{maxMb}} MB ou menos',
      invalidPrimaryColor: 'Insira uma cor #RRGGBB válida ou deixe em branco',
      invalidSaveBlocked: 'Corrija os campos de marca inválidos antes de salvar as informações do inventário',
      imageLoadError: 'Não foi possível carregar a imagem "{{name}}". Exclua-a e envie uma nova.',
      imageLoadErrorReadOnly: 'Não foi possível carregar a imagem "{{name}}"',
      downloadImage: 'Clique para baixar a imagem',
    },
    configuration: {
      title: 'Configuração',
      filesTotalSpace: 'Espaço total para arquivos (GB)',
    },
    confirmDeleteCycleHeader: 'Excluir este ciclo?',
    confirmDeleteCycle: `Tem certeza de que deseja excluir o ciclo {{cycle}}?\n\n$t(common.cantUndoWarning)\n\n
Se houver registros associados a este ciclo, eles serão excluídos.`,
    cycleForArenaMobile: 'Ciclo para Arena Mobile',
    keepNonApplicableValues: `Manter os valores dos atributos não relevantes`,
    keepNonApplicableValuesInfo: `Se desmarcado (padrão), durante a entrada de dados os valores dos atributos que deixam de ser relevantes são apagados (após a confirmação do usuário).
Se marcado, esses valores são mantidos no registro, mesmo que os atributos não sejam mais relevantes.`,
    deleteActivityLog: 'Limpar log de atividades',
    deleteActivityLogConfirm: {
      headerText: 'Limpar TODOS os dados de log de atividades deste inventário?',
      message: `
  - TODOS os dados de log de atividades do inventário **{{surveyName}}** serão excluídos;\n\n
  - o espaço ocupado no BD pelo inventário será reduzido;\n\n
  - isso não afetará os dados coletados do inventário;\n\n
  
  $t(common.cantUndoWarning)`,
      confirmName: 'Digite o nome deste inventário para confirmar:',
    },
    fieldManualLink: 'Link do manual de campo',
    map: 'Mapa',
    editInfo: 'Editar informações',
    viewInfo: 'Ver informações',

    preloadedMapLayers: {
      enabledMessage: 'Camadas de mapa pré-carregadas ativadas',
      title: 'Camadas de mapa pré-carregadas',
      fileName: 'Nome do arquivo',
      fileSize: 'Tamanho do arquivo',
      confirmDelete: 'Tem certeza de que deseja excluir esta camada de mapa pré-carregada?',
      editor: {
        title: 'Camada de mapa pré-carregada',
      },
    },

    surveyDocLayout: {
      tabTitle: 'Layout do documento',
      title: 'Imagens do documento',
      layoutOptions: {
        title: 'Opções de layout',
        headerOnFirstPageOnly: 'Cabeçalho somente na primeira página',
        pageNumbering: 'Numeração de páginas',
      },
      documentPlace: 'Local',
      documentPlaceValues: {
        header: 'Cabeçalho',
        footer: 'Rodapé',
      },
      applyIf: 'Aplicar se condição',
      confirmDelete: 'Tem certeza de que deseja excluir esta imagem do documento?',
      editor: {
        title: 'Imagem do documento',
      },
    },

    preferredLanguage: 'Idioma preferido',
    sampleBasedImageInterpretation: 'Interpretação de imagem baseada em amostra',
    sampleBasedImageInterpretationEnabled: 'Interpretação de imagem baseada em amostra habilitada',
    security: {
      title: 'Segurança',
      dataEditorViewNotOwnedRecordsAllowed: 'Editor de dados pode visualizar registros que não possui',
      dataAnalystViewNotOwnedRecordsAllowed: 'Analista de dados pode visualizar registros que não possui',
      visibleInMobile: 'Visível no Arena Mobile',
      allowRecordsDownloadInMobile: 'Permitir download de registros do servidor para o Arena Mobile',
      allowRecordsUploadFromMobile: 'Permitir upload de registros do Arena Mobile para o servidor',
      allowRecordsWithErrorsUploadFromMobile:
        'Permitir upload de registros com erros de validação do Arena Mobile para o servidor',
      allowRecordsMergeWithSameKeys:
        'Permitir a mesclagem de registros com as mesmas chaves (ex. registros criados em diferentes dispositivos Arena Mobile)',
    },
    srsPlaceholder: 'Digite código ou rótulo',
    unpublish: 'Despublicar e excluir dados',
    unpublishSurveyDialog: {
      confirmUnpublish: 'Tem certeza de que deseja despublicar este inventário?',
      unpublishWarning: `Despublicar o inventário **{{surveyName}}** excluirá todos os seus dados.\n\n
  
  $t(common.cantUndoWarning)`,
      confirmName: 'Digite o nome deste inventário para confirmar:',
    },
    userExtraProps: {
      title: 'Propriedades extras do usuário',
      info: `Propriedades extras que podem ser atribuídas a cada usuário associado ao inventário.  
Essas propriedades podem ser usadas em valores padrão, regras de validação e expressões de aplicabilidade.  
Ex.: *userProp('property_name') == 'some_value'*`,
    },
  },
  deleteSurveyDialog: {
    confirmDelete: 'Tem certeza de que deseja excluir este inventário?',
    deleteWarning: `Excluir o inventário **{{surveyName}}** apagará todos os seus dados.\n\n

$t(common.cantUndoWarning)`,
    confirmName: 'Digite o nome deste inventário para confirmar:',
  },
  surveyList: {
    active: '$t(common.active)',
    activate: 'Ativar',
  },
  collectImportReport: {
    excludeResolvedItems: 'Excluir itens resolvidos',
    expression: 'Expressão',
    resolved: 'Resolvido',
    exprType: {
      applicable: '$t(nodeDefEdit:advancedProps.relevantIf)',
      codeParent: 'Código pai',
      defaultValue: 'Valor padrão',
      requiredIf: 'Obrigatório se',
      validationRule: 'Regra de validação',
    },
    title: 'Relatório de Importação do Collect',
  },
  recordsSummary: {
    recordsAddedInTheLast: 'Registros adicionados nos últimos:',
    fromToPeriod: 'de {{from}} até {{to}}',
    record: '{{count}} Registro',
    record_other: '{{count}} Registros',
    week: '{{count}} Semana',
    week_other: '{{count}} Semanas',
    month: '{{count}} Mês',
    month_other: '{{count}} Meses',
    year: '{{count}} Ano',
    year_other: '{{count}} Anos',
  },
}
